/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Errors_Failedtosendotp3Inputs */

const he_auth_errors_failedtosendotp3 = /** @type {(inputs: Auth_Errors_Failedtosendotp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שליחת קוד חד-פעמי נכשלה`)
};

const en_auth_errors_failedtosendotp3 = /** @type {(inputs: Auth_Errors_Failedtosendotp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send one-time code`)
};

/**
* | output |
* | --- |
* | "Failed to send one-time code" |
*
* @param {Auth_Errors_Failedtosendotp3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_errors_failedtosendotp3 = /** @type {((inputs?: Auth_Errors_Failedtosendotp3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Errors_Failedtosendotp3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_errors_failedtosendotp3(inputs)
	return en_auth_errors_failedtosendotp3(inputs)
});
export { auth_errors_failedtosendotp3 as "auth_errors_failedToSendOtp" }